export class TicketCommentsDeleteRequest {
  ticketId: string
  ticketCommentId: string

  constructor(ticketId: string, ticketCommentId: string) {
    this.ticketId = ticketId
    this.ticketCommentId = ticketCommentId
  }
}
